import { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { LANGUAGES, LanguageContext } from "./languageContext";

export const LOCALE_KEY = "locale";

export default function LanguageProvider(props: { children: JSX.Element }) {
  const [locale, setLocale] = useState(getDefaultLocale);
  const [messages, setMessages] = useState<Record<string, string> | undefined>(
    undefined,
  );

  useEffect(() => {
    const importMessage = async () => {
      const messages = (await import(`../../../locale/${locale}.json`)) as {
        default: Record<string, string>;
      };
      setMessages(messages.default);
    };

    localStorage.setItem(LOCALE_KEY, locale);
    void importMessage();
  }, [locale]);

  if (!messages) {
    return null;
  }
  return (
    <LanguageContext.Provider value={{ locale, selectLanguage: setLocale }}>
      <IntlProvider
        messages={messages}
        locale={locale.replace("_", "-")}
        defaultLocale="en"
      >
        {props.children}
      </IntlProvider>
    </LanguageContext.Provider>
  );
}

function getDefaultLocale() {
  const storedLocale = localStorage.getItem(LOCALE_KEY);
  if (
    storedLocale &&
    LANGUAGES.find((language) => language.id === storedLocale)
  ) {
    return storedLocale;
  }
  const navigatorLanguage = navigator.language.split("-")[0];
  if (LANGUAGES.find((language) => language.id === navigatorLanguage)) {
    return navigatorLanguage;
  }
  return "en";
}
